<template>
  <div class="login">
    <body
      class="account-page"
      style="
        font-family: 'Quicksand', sans-serif;
        font-size: 0.9375rem;
        color: #1f1f1f;
        background-color: #f7f7f7;
        min-height: 100%;
        overflow-x: hidden;
      "
    >
      <!-- Main Wrapper -->
      <div class="main-wrapper">
        <div class="account-content" style="padding: 35px 0">
          <!-- <router-link to="/joblist"" class=" btn btn-primary apply-btn">Apply Job</router-link> -->
          <div class="container">
            <!-- Account Logo -->

            <!-- /Account Logo -->

            <div class="account-box">
              <div class="account-wrapper">
                <div class="row">
                  <div class="col-md-3">
                    <div class="account-logo">
                      <router-link to="/index"
                        ><img :src="logo" v-if="logo" alt="Sapphire HR" />
                        <img src="../assets/logo.png" v-if="!logo" alt="Sapphire HR" />
                      </router-link>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <h3 class="account-title">Forgot Password?</h3>
                    <p class="account-subtitle" v-if="viewOne">Enter the email address associated with your account</p>
                    <p class="account-subtitle" v-if="viewTwo">Enter the necessary information in the fields provided</p>
                  </div>
                </div>
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>{{ error }}</strong>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    @click="error = ''"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  class="alert alert-success alert-dismissible fade show"
                  role="alert"
                  v-if="alert"
                >
                  <strong>{{ alert }}</strong>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    @click="alert = null"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  class="alert alert-success alert-dismissible fade show"
                  role="alert"
                  v-if="submitted && viewTwo"
                >
                  <strong>{{ alert }}</strong>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    @click="toLogin"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&check;</span>
                  </button>
                </div>
                <!-- Account Form -->
                <form class="" v-if="viewOne">
                  <div class="form-group">
                    <label>Email Address</label>
                    <input
                      type="email"
                      v-model="email"
                      name="email"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group text-center">
                    <button
                      class="btn btn-primary account-btn"
                      :disabled="loading"
                      @click="submitMail"
                      type="button"
                    >
                      {{ !loading ? "Get Code" : "Loading.." }}
                    </button>
                  </div>
                  <div class="account-footer">
                    <p>
                      Return to Login?
                      <router-link to="/login">Click here</router-link>
                    </p>
                  </div>
                </form>
                <form @click.prevent="onSubmit()" class="" v-if="viewTwo">
                  <div class="form-group">
                    <label>Email Address</label>
                    <input
                      type="email"
                      disabled
                      v-model.trim="$v.email.$model"
                      name="email"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.email.$error }"
                    />
                    <div
                      v-if="submitted && !$v.email.required"
                      class="invalid-feedback"
                    >
                      Email is required
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Password</label>
                    <input
                      type="password"
                      v-model.trim="$v.password.$model"
                      name="password"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.password.$error }"
                    />
                    <div
                      v-if="submitted && !$v.password.required"
                      class="invalid-feedback"
                    >
                      Password is required
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Confirm Password</label>
                    <input
                      type="password"
                      v-model.trim="$v.confirmPassword.$model"
                      name="confirmPassword"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.confirmPassword.$error }"
                    />
                    <div
                      v-if="submitted && !$v.confirmPassword.required"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.confirmPassword.required"
                        >Confirm Password is required</span
                      >
                      <span v-else-if="!$v.confirmPassword.sameAsPassword"
                        >Passwords must match</span
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Code</label>
                    <input
                      type="text"
                      v-model.trim="$v.code.$model"
                      name="code"
                      class="form-control"
                      :class="{ 'is-invalid': submitted && $v.code.$error }"
                    />
                    <div
                      v-if="submitted && !$v.code.required"
                      class="invalid-feedback"
                    >
                      Code is required
                    </div>
                  </div>
                  <div class="form-group text-center">
                    <button
                      class="btn btn-primary account-btn"
                      :disabled="loading"
                      type="submit"
                    >
                      {{ !loading ? "Continue" : "Loading.." }}
                    </button>
                  </div>
                  <div class="account-footer">
                    <p>
                      return?
                      <a @click="back">Click here</a>
                    </p>
                  </div>
                </form>
                <!-- /Account Form -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Main Wrapper -->
    </body>
  </div>
</template>

<script>
import { required, sameAs } from "vuelidate/lib/validators";

import { router } from "@/router/index";
import { organizationService } from "@/services/organizationService";
import { authenticationService } from "@/services/authenticationService";

export default {
  data() {
    return {
      email: "",
      password: "",
      confirmPassword: "",
      code: "",
      submitted: false,
      loading: false,
      alert: null,
      success: false,
      logo: "",
      returnUrl: "",
      viewOne: true,
      viewTwo: false,
      error: "",
    };
  },
  validations: {
    email: { required },
    password: { required },
    confirmPassword: { required, sameAsPassword: sameAs("password") },
    code: { required }
  },
  created() {
    this.getOrg()
  },
  methods: {
    getOrg() {
      organizationService.getOrganization().then((o) => {
        this.theme = o.theme;
        this.logo = o.logo;
      });
    },
    submitMail () {
      this.loading = true
      var req = { email: this.email }
      authenticationService.forgot(req)
        .then(
          f => {
            console.log(f)
            this.loading = false
            this.alert = 'Check your inbox for an email sent to ' + this.email + '.'
            this.viewOne = false
            this.viewTwo = true
          },
          e => {
            this.loading = false
            this.error = e
          }
        )
    },
    back () {
      this.viewTwo = false
      this.viewOne = true
    },
    onSubmit() {

      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;
      this.alert = ''
      var req = {
        email: this.email,
        password: this.password,
        confirmPassword: this.confirmPassword,
        code: this.code
      }
      authenticationService.recovery(req).then(
        (user) => {
          this.loading = false
          this.submitted = true;
          this.alert = 'Your password has been reset successfully. Click the check mark to continue.'
        },
        (error) => {
          this.error = error;
          this.loading = false;
        }
      );
    },
    toLogin () {
      this.alert = ''
      this.submitted = false
      this.$router.push('/login')
      this.back()
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/forgotPassword.vue